window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};
$( document ).ready(function() {
  if($(window).width() > 1024) {
    // $('.prom-tuxedo-features').slick('unslick');
    
    if($('.prom-tuxedo-features .store-info').hasClass('slick-initialized')){
      $('.prom-tuxedo-features .store-info').slick('unslick');
    }
  }

  // Product Page start
  var $product_container = $('[data-section-type=product]');
  $product_container.on('variantChange', updateVariantRelatedFields.bind(this));

  // Product Page end

});

function updateVariantRelatedFields(evt) {
  let variant = evt.variant;
  if (variant){
    if (variant.available) {
      $('.product__inquiry-btn').hide();
      $('.arrival_date').hide();
    }else{
      $('.product__inquiry-btn').show();
      $('.arrival_date').show();
    }
  }
}

var addinToCart = window.newAddinToCart;
window.newAddinToCart = function() {
  addinToCart();
  console.log('extend---------')
}

// ------------------------------
// Mobile Fullscreen Image Zoom
// + Close Button
// + Fade-In Animation
// + Swipe Left/Right for Next/Prev Images
// ------------------------------
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 900) return; // mobile only

  const slider = document.querySelector('.primgSlider');
  if (!slider) return;

  // Collect ALL product image zoom URLs
  const slides = Array.from(document.querySelectorAll('.product-single__photo'));
  const zoomImages = slides.map(slide => slide.getAttribute('data-zoom'));

  // Tap handler for any slide
  slider.addEventListener('click', function (e) {
    const photo = e.target.closest('.product-single__photo');
    if (!photo) return;

    const startIndex = slides.indexOf(photo);
    if (startIndex === -1) return;

    openFullscreenGallery(startIndex);
  });

  // ------------------------------
  // FULLSCREEN GALLERY VIEWER
  // ------------------------------
  function openFullscreenGallery(startIndex) {
    let index = startIndex;

    // Remove old modal if exists
    const oldModal = document.getElementById('pt-fullscreen-viewer');
    if (oldModal) oldModal.remove();

    // Modal wrapper
    const modal = document.createElement('div');
    modal.id = 'pt-fullscreen-viewer';
    modal.style.cssText = `
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.95);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999999;
      opacity: 0;
      transition: opacity .5s ease;
      overflow: hidden;
    `;

    // Image element
    const img = document.createElement('img');
    img.style.cssText = `
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      transition: transform .25s ease;
    `;

    // Function to load an image
    function loadImage(i) {
      img.src = zoomImages[i];
    }
    loadImage(index);

    // Fade in
    requestAnimationFrame(() => {
      modal.style.opacity = "1";
    });

    // ------------------------------
    // CLOSE BUTTON
    // ------------------------------
    const closeBtn = document.createElement('div');
    closeBtn.innerHTML = "&times;";
    closeBtn.style.cssText = `
      position: absolute;
      top: 14px;
      right: 14px;
      font-size: 32px;
      color: white;
      cursor: pointer;
      padding: 6px 10px;
      background: rgba(0,0,0,.35);
      border-radius: 8px;
      z-index: 1000000;
    `;
    closeBtn.addEventListener('click', closeModal);

    function closeModal() {
      modal.style.opacity = "0";
      setTimeout(() => modal.remove(), 250);
    }

    // ------------------------------
    // SWIPE HANDLING
    // ------------------------------
    let startX = 0;
    let endX = 0;

    modal.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    });

    modal.addEventListener('touchend', function (e) {
      endX = e.changedTouches[0].clientX;
      handleSwipe();
    });

    function handleSwipe() {
      const diff = endX - startX;

      // Require a stronger, intentional swipe (110px)
const SWIPE_THRESHOLD = 110;
if (Math.abs(diff) < SWIPE_THRESHOLD) return;

      if (diff < 0) {
        // Swipe LEFT → next image
        if (index < zoomImages.length - 1) {
          index++;
          loadImage(index);
        }
      } else {
        // Swipe RIGHT → previous image
        if (index > 0) {
          index--;
          loadImage(index);
        }
      }
    }

    // Prevent accidental closure when touching image
    img.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    modal.addEventListener('click', closeModal);

    modal.appendChild(img);
    modal.appendChild(closeBtn);
    document.body.appendChild(modal);
  }
});

